import { render, staticRenderFns } from "./ShareholderBus.vue?vue&type=template&id=31f7bca2&"
import script from "./ShareholderBus.vue?vue&type=script&lang=js&"
export * from "./ShareholderBus.vue?vue&type=script&lang=js&"
import style0 from "./ShareholderBus.vue?vue&type=style&index=0&id=31f7bca2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports